import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { SettingsRootParamList } from "../../../../types";
import { Card, FlatActionList, Page } from "@towersystems/roam-common-native";
import { useMutation } from "@apollo/client";
import {
  LinklyConfiguration,
  ReceiptAutoPrintType,
} from "@towersystems/roam-common/lib/generated-types";
import React from "react";
import { MUTATION_UPDATE_LINKLY_CONFIGURATION } from "../../common/constants";

export type LinklySettingsEditAutoPrintScreenProps = NativeStackScreenProps<
  SettingsRootParamList,
  "LinklySettingsEditAutoPrintScreen"
>;

export const LinklySettingsEditAutoPrintScreen = ({
  route,
  navigation,
}: LinklySettingsEditAutoPrintScreenProps) => {
  const { paymentMethodId, selectedValue } = route.params;

  const [m] = useMutation<{
    updateLinklyConfiguration: LinklyConfiguration;
  }>(MUTATION_UPDATE_LINKLY_CONFIGURATION);

  const handleOnSelectedOption = React.useCallback(
    (receiptAutoPrint: ReceiptAutoPrintType) => {
      m({
        variables: {
          paymentMethodId: paymentMethodId,
          input: {
            receiptAutoPrint,
          },
        },
      })
        .then(() => {
          navigation.goBack();
        })
        .catch((error) => console.log(error));
    },
    [paymentMethodId]
  );

  return (
    <Page title="Select Print Option">
      <Card>
        <FlatActionList
          items={[
            {
              key: "pos",
              title: "POS",
              subTitle: "Print all receipts from POS",
              selected: selectedValue === "POS",
              onPress() {
                handleOnSelectedOption(ReceiptAutoPrintType.POS);
              },
            },
            {
              key: "pinpad",
              title: "Pinpad",
              subTitle: "Print all receipts from Pinpad",
              selected: selectedValue === "PinPad",
              onPress() {
                handleOnSelectedOption(ReceiptAutoPrintType.PinPad);
              },
            },
            {
              key: "both",
              title: "Both",
              subTitle:
                "Print all merchant/signature receipts from the PIN pad printer, and all customer receipts from the POS printer.",
              selected: selectedValue === "Both",
              onPress() {
                handleOnSelectedOption(ReceiptAutoPrintType.Both);
              },
            },
          ]}
        />
      </Card>
    </Page>
  );
};
